import { s as o } from "./symbol-constructor-detection.js";
var r = o && !!Symbol.for && !!Symbol.keyFor;
export { r as s };